import type { Distribution } from "@memorang/types";
import { sortedMasteryLevels } from "@memorang/ui/src/components/DonutChart/helpers";
import type { Content } from "types/tag";

const calculateParentDist = (contents: Content[]) => {
	const parentDist = sortedMasteryLevels
		.map((item) => item.id)
		.reduce<Record<string, number>>((acc, curr) => {
			acc[curr] = 0;
			return acc;
		}, {});
	const accumulateDist = (dist: Distribution) => {
		for (const key of Object.keys(dist)) {
			const finalKey = key as keyof Distribution;
			parentDist[finalKey] = parentDist[finalKey] || 0;
			parentDist[finalKey] += dist[finalKey];
		}
	};

	for (const content of contents) {
		accumulateDist(content.distribution);
	}

	return parentDist;
};

const getParentMetadata = (contents: Content[], _numItems: number) => {
	const dist = calculateParentDist(contents);
	return {
		distribution: dist,
		isFavorited: false,
		permissions: ["VIEW"],
	};
};

export { getParentMetadata };
